module.exports = __webpack_public_path__ + "static/img/15.6c01151.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/生活照/15.jpg
// module id = fNxT
// module chunks = 0